export default __webpack_public_path__ + "static/media/youtube.023fa7c9.png";